import React from "react";
import "./index.scss";
import CheckBox from "devextreme-react/check-box";
import { IMdaeChecBoxProps } from "./index";
import {
  DX_WIDGET_NAMES,
  configureMdaeWidgetOptionUpdaters,
} from "../../mdae-framework";
import { useDispatch } from "react-redux";
const MdaeCheckBox: React.FC<IMdaeChecBoxProps> = (props) => {
  const dispatch = useDispatch();
  return (
    <div className={"sys-mdae-checkbox-container"}>
      <CheckBox
        {...props}
        onInitialized={(e) => {
          if (typeof props.onInitialized === "function") props.onInitialized(e);
          configureMdaeWidgetOptionUpdaters(
            props.mdaeDataUpdaterConfig,
            DX_WIDGET_NAMES.DX_CHECK_BOX,
            e.component,
            dispatch
          );
        }}
      ></CheckBox>
    </div>
  );
};
export default MdaeCheckBox;
